<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Modos de Jogo
      </span>

      <h3 class="text-center mt-5">Modos de Jogo</h3>
    </header>

    <table
      v-for="mode in modes"
      :key="mode.id"
      class="table table-dark table-striped mt-5"
    >
      <thead>
        <tr>
          <th class="text-center text-uppercase font-weight-bold" colspan="2">
            {{ mode.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">
            <span class="text-uppercase mr-2">Número mínimo de jogadores:</span>
            {{ mode.players.min }}
          </td>
          <td class="text-center">
            <span class="text-uppercase mr-2">Número máximo de jogadores:</span>
            {{ mode.players.max }}
          </td>
        </tr>

        <tr>
          <td class="text-center">
            <span class="text-uppercase mr-2">
              Número mínimo de personagens por jogador:
            </span>
            {{ mode.characters.min }}
          </td>
          <td class="text-center">
            <span class="text-uppercase mr-2">
              Número máximo de personagens por jogador:
            </span>
            {{ mode.characters.max }}
          </td>
        </tr>

        <tr>
          <td colspan="2" class="text-justify">{{ mode.desc }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import modes from '../data/modes'

export default {
  name: 'modes',

  data: () => ({
    modes: modes.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    )
  })
}
</script>
